export default __webpack_public_path__ + "15bc6eda897cdf19dbdff22b70ceef0e.svg";